import { Fragment, useContext } from 'react';
import { Button, Link, Stack, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { VaultContext } from '@/contexts/vaultContext';
import { useLocalization } from '@/hooks/useLocalization';

const PersonalStorageNavigation = () => {
  const { folderPath, setFolderPath } = useContext(VaultContext);
  const { t } = useLocalization();

  if (folderPath.length === 0) {
    return null;
  }

  const rootName = t('personalStorage');
  const backName =
    folderPath.length > 1 ? folderPath[folderPath.length - 2].name : rootName;

  return (
    <Stack
      direction='row'
      alignItems='center'
      flexWrap='wrap'
      gap={2}
      sx={{ flexShrink: 0, marginBottom: 2 }}
    >
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => {
          setFolderPath(folderPath.slice(0, -1));
        }}
        sx={{
          textTransform: 'none',
          fontWeight: 500,
          overflowWrap: 'anywhere',
        }}
      >
        {t('documentVault.backTo', { name: backName })}
      </Button>
      <Stack
        direction='row'
        alignItems='center'
        flexWrap='wrap'
        gap={1}
      >
        <Link
          component='button'
          type='button'
          underline='hover'
          onClick={() => {
            setFolderPath([]);
          }}
        >
          {rootName}
        </Link>
        {folderPath.map((folder, index) => {
          const isCurrent = index === folderPath.length - 1;
          return (
            <Fragment key={folder.id}>
              <Typography
                component='span'
                aria-hidden
              >
                ›
              </Typography>
              {isCurrent ? (
                <Typography
                  component='span'
                  sx={{ fontWeight: 600, overflowWrap: 'anywhere' }}
                >
                  {folder.name}
                </Typography>
              ) : (
                <Link
                  component='button'
                  type='button'
                  underline='hover'
                  onClick={() => {
                    setFolderPath(folderPath.slice(0, index + 1));
                  }}
                  sx={{ overflowWrap: 'anywhere' }}
                >
                  {folder.name}
                </Link>
              )}
            </Fragment>
          );
        })}
      </Stack>
    </Stack>
  );
};

export default PersonalStorageNavigation;
